// extracted by mini-css-extract-plugin
module.exports = {"clamped":"LineClampedText_clamped__0w0Sq"};